import MasterHeader from './master-header.component'

export default MasterHeader
